export default "__VITE_ASSET__035c5ad0__"